/* DM-NAV-A11Y-HOOK v1
 * Keeps keyboard focus inside the mobile navigation drawer without replacing
 * Impact's native drawer, animation, Escape handling, or ARIA state updates.
 */
(() => {
  const drawerId = 'header-sidebar-menu';
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const isVisible = (element) => {
    if (element.closest('[hidden], [inert]') || element.getClientRects().length === 0) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const getFocusableElements = (drawer) =>
    Array.from(drawer.querySelectorAll(focusableSelector)).filter(isVisible);

  const enhanceDrawer = () => {
    const drawer = document.getElementById(drawerId);

    if (!drawer || drawer.dataset.dmNavA11yEnhanced === 'true') {
      return;
    }

    drawer.dataset.dmNavA11yEnhanced = 'true';

    drawer.addEventListener('dialog:after-show', () => {
      const firstFocusable = getFocusableElements(drawer)[0];

      window.requestAnimationFrame(() => {
        const activeElement = document.activeElement;
        const hasLightDomFocus = activeElement !== drawer && drawer.contains(activeElement);
        const hasShadowDomFocus = activeElement === drawer && drawer.shadowRoot?.activeElement;

        if (!hasLightDomFocus && !hasShadowDomFocus) {
          firstFocusable?.focus({ preventScroll: true });
        }
      });
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') {
        return;
      }

      const focusableElements = getFocusableElements(drawer);
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements.at(-1);

      if (!firstFocusable || !lastFocusable) {
        return;
      }

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus({ preventScroll: true });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDrawer, { once: true });
  } else {
    enhanceDrawer();
  }

  document.addEventListener('shopify:section:load', enhanceDrawer);
})();

